import autoPageview from './directives/auto-pageview'
import trackEvent from '././directives/track-event'
import trackPageview from '././directives/track-pageview'

  /**
   * install
   *
   * @param {Vue} Vue
   * @param {Object} options
   * @returns
   */
export default function install (Vue, options) {
  if (this.install.installed) return

  if (options.debug) {
    this.debug = console.debug
  } else {
    this.debug = () => {}
  }

  let siteId_cnzz = null
  let siteId_stat = null
  // passsing siteId through object or string
  if (typeof options === 'object') {
    siteId_cnzz = options.cnzz.siteId
    siteId_stat = options.stat.siteId

    if (options.autoPageview !== false) {
      options.autoPageview = true
    }
  } else {
    return console.error('options type error')
  }
  if (!siteId_cnzz) {
    return console.error('siteId_cnzz is missing')
  }
  this.install.installed = true

  // insert u-web statistics script
  const script_cnzz = document.createElement('script')
  const src_cnzz = `https://s95.cnzz.com/z_stat.php?id=${siteId_cnzz}&web_id=${siteId_cnzz}`
  script_cnzz.src = options.cnzz.src || src_cnzz

  // insert stat statistics script
  const script_stat = document.createElement('script')
  const src_stat = `http://www.mi2c.com/stat/stat.js?siteid=${siteId_stat}`
  script_stat.src = options.stat.src || src_stat

  // callback when the script is loaded
  script_cnzz.onload = () => {
    // if the global object is exist, resolve the promise, otherwise reject it
    this.install._cnzzLoaded = true
    if (window._czc) {
      if (this.install._cnzzLoaded && this.install._statLoaded) {
        this._resolve()
      }

    } else {
      console.error('loading uweb statistics script failed, please check src and siteId')
      if (this.install._cnzzLoaded && this.install._statLoaded) {
        return this._reject()
      }
    }
    // load from cache
    this._cache.forEach((cache) => {
      window._czc.push(cache)
    })
    if (this.install._cnzzLoaded && this.install._statLoaded) {
      this._cache = []
    }
  }

  script_stat.onload = () => {
    this.install._statLoaded = true
    if (window._stat) {
      if (this.install._cnzzLoaded && this.install._statLoaded) {
        this._resolve()
      }

    } else {
      console.error('loading stat script failed, please check src and siteId')
      if (this.install._cnzzLoaded && this.install._statLoaded) {
        return this._reject()
      }
    }
    // load from cache
    this._cache.forEach((cache) => {
      window._stat.push(cache)
    })
    if (this.install._cnzzLoaded && this.install._statLoaded) {
      this._cache = []
    }
  }

  window._stat = []
  window._czc = []
  window._czc.push(["_setAutoPageview", options.autoPageview])
  window._stat.push(["_setAutoPageview", options.autoPageview])

  document.body.appendChild(script_cnzz)
  document.body.appendChild(script_stat)

  // store into cache when the script is not fully loaded
  // add $czc to Vue prototype
  Object.defineProperty(Vue.prototype, '$uweb', {
    get: () => this
  })

  Vue.directive('auto-pageview', autoPageview)
  Vue.directive('track-event', trackEvent)
  Vue.directive('track-pageview', trackPageview)
}



// WEBPACK FOOTER //
// ./src/plugins/uweb/install.js